<div class="dialog-backdrop" [attr.data-testid]="testIds.dialogBackdrop"></div>
<div #dialogContainer class="dialog-container" [attr.data-testid]="testIds.dialogContainer">
  <div class="dialog-header" [attr.data-testid]="testIds.dialogHeader">
    <button (click)="closeDialog()" class="back-button" [attr.data-testid]="testIds.buttonBack">
      <mat-icon svgIcon="arrow-left" [attr.data-testid]="testIds.iconBack"></mat-icon>
      {{ backButtonText }}
    </button>
  </div>

  <div class="dialog-content" [attr.data-testid]="testIds.dialogContent">
    <mat-nav-list class="dialog-sidebar" [attr.data-testid]="testIds.listChatSettings">
      @for (tab of tabs; track tab.path) {
        <a
          mat-list-item
          style="display: inline-flex; width: auto"
          [disableRipple]="true"
          [routerLink]="tab.path"
          routerLinkActive="active"
          class="tab-item"
          [attr.data-testid]="'list_item_' + tab.path"
          (click)="updateTitle(tab.label)">
          {{ tab.label }}
          <mat-icon svgIcon="arrow-right" class="tab-icon-right"></mat-icon>
        </a>
      }
    </mat-nav-list>

    <div class="dialog-main-content" [attr.data-testid]="testIds.dialogMainContent" mat-dialog-content>
      <div class="dialog-title-bar">
        <h2 class="dialog-title" [attr.data-testid]="testIds.dialogTitle">{{ dialogTitle }}</h2>
        @if (headerActionsService.tpl$ | async; as tpl) {
          <div class="dialog-header-actions">
            <ng-container *ngTemplateOutlet="tpl"></ng-container>
          </div>
        }
      </div>
      <hr class="title-separator" [attr.data-testid]="testIds.dividerTitle" />
      <div class="route-scroll-x">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
